import { createFileRoute } from "@tanstack/react-router";

import KnowledgeBasesAdmin from "@/components/KnowledgeBasesAdmin";

// Generated to match `src/app/admin/knowledge-bases/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/knowledge-bases")({
  component: KnowledgeBasesAdmin,
});
